module.exports = "/_next/static/images/broadcast-ea0be01848c20ab3a7b784232269238a.svg";